import React from 'react';
import { Line } from 'Components/frameworks/line/Line';
import type { LineProps } from 'Components/frameworks/line/Line';
type Props = {
  index?: number;
  header: {
    title: string;
    id?: string;
    iconName?: IconName;
  };
  tabId?: string;
  lines: ReadonlyArray<LineProps>;
};

const TabLine = ({ lines, ...props }: Props) => {
  const tabId = props.tabId || props.index;
  const tabProps = {
    ...props,
    lines: lines.map(({ props: lineProps, ...line }) => ({
      ...line,
      props: { ...lineProps, tabId },
    })),
  };
  return <Line props={tabProps} />;
};

export default TabLine;
